import Products from './Products';
import { useAppSelector } from '../../store/hooks';


export default function TabHome()
{
    const appData = useAppSelector((state) => state.appData)
    return (<div className="main-body">
        {appData.products && appData.products.length > 0 && <Products />}
    </div>
    );
}